<!--
 * @Author: Lemon C
 * @Date: 2024-12-11 11:20:31
 * @LastEditTime: 2025-03-12 11:50:50
-->
<template>
    <div class="sup-video-course-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">视频教程</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_vedio_click" />
            </div>
            <div class="grid-list-box">
                <div class="grid-item-box" v-for="(item, index) in course_video_list" :key="`item_${index}`" @click="jump_vedio_item_click(item)">
                    <img class="grid-item-img" :src="require(`@/assets/imgs/devDoc/${item.img}.png`)" />
                    <img class="item-play-img" src="@/assets/imgs/general/icon_vedio_play.png" />
                    <div class="gird-item-title-box">
                        <img class="item-icon" :src="require(`@/assets/imgs/devDoc/${item.icon}.png`)" />
                        <span class="item-title">{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    course_video_list: {
        type: Array,
        default: () => [],
    },
});

// MARK Click  跳转视频教程
const jump_vedio_click = () => {
    router_store.windowOpenToBilibli();
};

// MARK Click Item  跳转视频教程
const jump_vedio_item_click = (item) => {
    router_store.windowOpenTo(item.url);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-video-course-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 56px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 60px;
        row-gap: 40px;

        .grid-item-box {
            position: relative;
            display: flex;
            height: 240px;
            align-items: center;
            border-radius: 10px;
            cursor: pointer;
            overflow: hidden;
            flex-direction: column;
            background-color: var(--color-main-light-bg-white);
            box-shadow: var(--color-main-card-shadow-big);

            .grid-item-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }

            .item-play-img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 43px;
                height: 43px;
                transition: var(--animation-opacity-style);
                opacity: 0.82;
            }

            .gird-item-title-box {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 53px;
                display: flex;
                align-items: center;
                padding: 0 13px;
                box-sizing: border-box;
                backdrop-filter: blur(10px);

                .item-icon {
                    position: relative;
                    width: 28px;
                    height: 28px;
                }

                .item-title {
                    position: relative;
                    margin-left: 13px;
                    height: 30px;
                    font-weight: 400;
                    font-size: 20px;
                    color: var(--color-main-text-dark-bg-primary);
                }
            }

            &:hover .item-play-img {
                opacity: 1.0;
            }
        }
    }
}
</style>
